declare let mxConstants: any;
import * as util from '../styles.util';
import {ServerStyleObject} from '../styles.model';
import {StyleKeeper} from './style-keeper.model';

export class SwimlaneStyleKeeper implements StyleKeeper {
  constructor(
    private readonly swimlane,
    private readonly styles: ServerStyleObject
  ) {}

  public original() {
    return this.styles;
  }

  public mxCellCss() {
    const result = {
      [mxConstants.STYLE_SHAPE]: mxConstants.SHAPE_SWIMLANE,
      [mxConstants.STYLE_FILLCOLOR]: 'transparent',
      [mxConstants.STYLE_ROUNDED]: 0,
      [mxConstants.STYLE_SWIMLANE_FILLCOLOR]: this.styles.backgroundColor,
      resizable: 0,
      editable: 0,
      rotatable: 0,
      selectable: 0,
      horizontal: this.styles.horizontal,
      fontSize: 14,
      fontFamily: this.styles.font,
      fontStyle: util.calculateFontStyle(this.styles),
      fontColor: this.styles.fontColor,
      strokeColor: this.styles.borderColor
    };

    return util.objectToString(result, '=');
  }
}
